import * as Fetch from '@/helpers/fetch'

export const getConfigs = async (): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/configurations`

  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
